import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { SentinelBusyProvider } from "@/lib/sentinel-busy";
import Protected from "@/components/Protected";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import Exercises from "@/pages/Exercises";
import Practical from "@/pages/Practical";
import PracticalExercise from "@/pages/PracticalExercise";
import Coverage from "@/pages/Coverage";
import Badges from "@/pages/Badges";
import VerifyBadge from "@/pages/VerifyBadge";
import Metrics from "@/pages/Metrics";
import SquadList from "@/pages/SquadList";
import SquadDetail from "@/pages/SquadDetail";
import Assistant from "@/pages/Assistant";
import Org from "@/pages/Org";
import Trust from "@/pages/Trust";
import Security from "@/pages/Security";
import Scenarios from "@/pages/Scenarios";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SentinelBusyProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/courses" element={<Protected><Courses /></Protected>} />
            <Route path="/courses/:courseId" element={<Protected><CourseDetail /></Protected>} />
            <Route path="/exercises" element={<Protected><Exercises /></Protected>} />
            <Route path="/practical" element={<Protected><Practical /></Protected>} />
            <Route path="/practical/:slug" element={<Protected><PracticalExercise /></Protected>} />
            <Route path="/coverage" element={<Protected><Coverage /></Protected>} />
            <Route path="/badges" element={<Protected><Badges /></Protected>} />
            <Route path="/verify/:badgeId" element={<VerifyBadge />} />
            <Route path="/metrics" element={<Protected><Metrics /></Protected>} />
            <Route path="/squad" element={<Protected><SquadList /></Protected>} />
            <Route path="/squad/:traineeId" element={<Protected><SquadDetail /></Protected>} />
            <Route path="/assistant" element={<Protected><Assistant /></Protected>} />
            <Route path="/org" element={<Protected><Org /></Protected>} />
            <Route path="/trust" element={<Trust />} />
            <Route path="/security" element={<Protected><Security /></Protected>} />
            <Route path="/scenarios" element={<Protected><Scenarios /></Protected>} />
          </Routes>
          </BrowserRouter>
        </SentinelBusyProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
